/**
 * Created by hp on 2017/8/22.
 */
import ComplainAccount from './ComplainAccount';
import ComplainBody from './ComplainBody';
import ComplainContact from './ComplainContact';
import ComplainItem from './ComplainItem';


export {
    ComplainAccount,
    ComplainBody,
    ComplainContact,
    ComplainItem,
}


// WEBPACK FOOTER //
// ./src/components/complain/index.js